export default "__VITE_ASSET__Ci$yFQr9__"